import {useRouter} from 'next/router';
import {useIntl} from 'react-intl';
import {Modal, ModalOverlay, ModalContent, ModalBody, ModalFooter, Flex, Image, Text, Center} from '@chakra-ui/react';

import {getCountry} from '@eksab/util';
import {useTranslate} from '@eksab/i18n';
import BellIcon from '../../icons/bell.png';

import {TriviaIcon} from '../../icons/TriviaIcon';
import {CoinsIcon, HomeIcon} from '@eksab/assets/icons';
import NextLink from 'next/link';
import {useEffect} from 'react';
import {useTriviaStore} from '../../state';

export function QuizClosedModal() {
  const router = useRouter();
  const format = useIntl().formatNumber;

  const t = useTranslate();
  const returnURL = useTriviaStore((state) => (state.challenge?.topic === 'art' ? '/kataflam' : '/derby'));
  const entryFee = useTriviaStore((state) => state.challenge?.entry_fee ?? 0);
  const isOpen = useTriviaStore((state) => state.isClosed && (state.state === 'warm-up' || state.state === 'question'));
  const prevAppLocale = useTriviaStore((state) =>
    state.prevAppLanguage ? `${state.prevAppLanguage}-${getCountry(router.locale)}` : undefined,
  );

  useEffect(() => {
    if (isOpen) {
      mixpanel?.track('Challenge expired modal opened');
    }
  }, [isOpen]);

  return (
    <Modal
      closeOnOverlayClick={false}
      size="sm"
      variant="full"
      motionPreset="slideInBottom"
      isOpen={isOpen}
      onClose={() => router.replace(returnURL, undefined, {locale: prevAppLocale})}
    >
      <ModalOverlay />

      <ModalContent px="3" py="4" rounded="3xl" maxH="90vh" overflow="auto">
        <ModalBody px="0" pt="1.125rem" pb="8" display="flex" flexDir="column" gap="3" bg="white">
          <Flex alignSelf="center" align="center" gap="6" px="3.5" py="2" flexDir="column">
            <Image src={BellIcon.src} alt="" width="240px" height="auto" filter="grayscale(0.8)" />
            <Flex flexDir="column" gap="2" align="center" textAlign="center">
              <Text fontSize="28px" fontWeight="800">
                {t('trivia.quiz.closed.title')}
              </Text>
              <Text fontSize="20px" fontWeight="700">
                {t('trivia.quiz.closed.heading')}
              </Text>
              <Text fontSize="14px" fontWeight="600" textColor="#6C6C6C">
                {t('trivia.quiz.closed.subheading')}
              </Text>
            </Flex>

            <Center gap="3" py="2.5" px="4" rounded="34px" border="0.5px solid #1BA482" bgColor="#E9FFF4">
              <CoinsIcon height="6" width="auto" />
              <Text fontSize="18px" fontWeight="800" word-wrap="keep-all" whiteSpace="nowrap">
                {format(entryFee)} ₡
              </Text>
              <Text fontSize="12px" fontWeight="700" textAlign="center">
                {t('trivia.quiz.closed.refund')}
              </Text>
            </Center>
          </Flex>
        </ModalBody>

        <ModalFooter p="3" gap="10" justifyContent="space-between">
          <Center as={NextLink} href="/" locale={prevAppLocale} bg="white" flexDir="column">
            <HomeIcon stroke="#6C6C6C" />
            <Text fontSize="14px" fontWeight="500" textColor="#6C6C6C">
              {t('app.home')}
            </Text>
          </Center>

          <Flex
            as={NextLink}
            href="/trivia"
            locale={prevAppLocale}
            px="6"
            py="3"
            gap="6"
            rounded="full"
            display="flex"
            alignItems="center"
            bgColor="#FAFAFA"
            borderWidth="1px"
            borderColor="#DAE2DA"
          >
            <Text fontSize="xs" fontWeight="bold">
              {t('trivia.more-games')}
            </Text>
            <TriviaIcon fill="green.400" />
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
